import store from '../../../../store';
export default function checkIfCanReset() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (
    scopes.includes('user_account_credentials_reset_all') ||
    scopes.includes('user_account_credentials_reset_self') ||
    scopes.includes('user_account_credentials_reset_company')
  ) {
    exists = true;
  }
  return exists;
}
